import { Component } from '@angular/core';
import { BreadcrumbItem } from '../../../shared-components/custom-breadcrumbs/custom-breadcrumbs.component';

@Component({
	selector: 'app-custom-breadcrumbs-showcase',
	templateUrl: './custom-breadcrumbs-showcase.component.html',
	styleUrls: ['./custom-breadcrumbs-showcase.component.scss'],
	standalone: false,
})
export class CustomBreadcrumbsShowcaseComponent {
	public readonly singleItem: BreadcrumbItem[] = [{ label: 'Home' }];

	public readonly twoLevels: BreadcrumbItem[] = [{ label: 'Home', route: '/' }, { label: 'Design System' }];

	public readonly threeLevels: BreadcrumbItem[] = [{ label: 'Home', route: '/' }, { label: 'Documents', route: '/' }, { label: 'Invoice details' }];

	public readonly deepHierarchy: BreadcrumbItem[] = [
		{ label: 'Home', route: '/' },
		{ label: 'Companies', route: '/' },
		{ label: 'Company details', route: '/' },
		{ label: 'Contracts', route: '/' },
		{ label: 'Contract 2024-001', route: '/' },
		{ label: 'Edit' },
	];

	public readonly arrayRoutes: BreadcrumbItem[] = [
		{ label: 'Home', route: ['/'] },
		{ label: 'Design System', route: ['/'] },
		{ label: 'Breadcrumbs' },
	];

	public readonly withoutRoutes: BreadcrumbItem[] = [{ label: 'Home' }, { label: 'Documents' }, { label: 'Invoice details' }];

	public readonly longLabels: BreadcrumbItem[] = [
		{ label: 'Home', route: '/' },
		{ label: 'A considerably long section name that describes the area', route: '/' },
		{ label: 'Another very long label for the current page that may wrap on smaller screens' },
	];
}
